module.exports = __webpack_public_path__ + "static/media/thumbnail-video-3@3x.4fcfe500.png";